import { Component, HostListener, Injectable, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatMenuTrigger } from '@angular/material/menu';
import { Router } from '@angular/router';
import { Constants } from '../../Constants/Constants';
import { AuthService } from '../../services/auth.service';
import { TranslateService } from '../../services/translate.service';
import { WhitelabelService } from '../../services/whitelabel.service';
import { ReportIssueComponent } from '../report-issue/report-issue.component';


@Component({
  selector: 'wdm-header-root',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
@Injectable()
export class HeaderComponent {
  appName = "ProcessEye";
  userName = "";
  isCreator: boolean;
  isReviewer: boolean;
  isTechManager: boolean;
  isDesignerManager: boolean;
  public dialogRef: MatDialogRef<ReportIssueComponent>;

  @ViewChild('mobileMenuTrigger') mobileMenuTrigger: MatMenuTrigger;
  @ViewChild('configTrigger') configTrigger: MatMenuTrigger;

  constructor(private router: Router, private translate: TranslateService, private auth: AuthService, public dialog: MatDialog,
    private whitelabelService: WhitelabelService) {

    this.userName = localStorage.getItem(Constants.UserName);
    this.isCreator = this.auth.IsCreator();
    this.isReviewer = this.auth.IsReviewer();
    this.isTechManager = this.auth.IsTechManager();
    this.isDesignerManager = this.auth.IsDesignerManager();
  }

  // The hamburger/gear triggers are hidden by CSS on either side of the
  // responsive breakpoint, so a menu left open while resizing across it
  // loses its anchor and renders stuck at the viewport's top-left corner.
  @HostListener('window:resize')
  onWindowResize() {
    this.mobileMenuTrigger?.closeMenu();
    this.configTrigger?.closeMenu();
  }

  Logout() {
    localStorage.removeItem(Constants.Token);
    localStorage.removeItem(Constants.UserName);
    localStorage.removeItem(Constants.IsCreator);
    localStorage.removeItem(Constants.IsReviewer);
    localStorage.removeItem(Constants.IsTechManager);
    localStorage.removeItem(Constants.IsDesignerManager);
    this.whitelabelService.clearClientWhitelabel();
    this.router.navigate(['/'],{ queryParamsHandling: "merge" });
  }

  openReportIssue() {
    console.log('open report Issue');
    this.dialogRef = this.dialog.open(ReportIssueComponent, {
      width: 'auto',
    });
  }

  setLang(lang: string) {
    this.translate.use(lang);
  }
}
